module.exports = __webpack_public_path__ + "img/fl-icon-dark.e9a88a2c.svg";